import { StateCreator } from 'zustand';
import { UIActions, GalaxyStore, CameraMode, FilterSettings, PerformanceMetrics, UISettings, InteractionState } from '../types';

export interface UISlice extends UIActions {}


export const createUISlice: StateCreator<
  GalaxyStore,
  [],
  [],
  UISlice
> = (set) => ({
  // Actions only - state is defined in main store
  selectObject: (objectId: string | null) => set((state) => {
    return {
      ...state,
      ui: {
        ...state.ui,
        selectedObject: objectId,
      },
    };
  }),

  setCameraMode: (mode: CameraMode) => set((state) => {
    return {
      ...state,
      ui: {
        ...state.ui,
        cameraMode: mode,
      },
    };
  }),

  setTimeScale: (scale: number) => set((state) => {
    return {
      ...state,
      ui: {
        ...state.ui,
        timeScale: Math.min(Math.max(scale, 0.1), 10), // Clamp between 0.1 and 10
      },
    };
  }),

  updateFilters: (filters: Partial<FilterSettings>) => set((state) => {
    return {
      ...state,
      ui: {
        ...state.ui,
        filters: {
          ...state.ui.filters,
          ...filters,
        },
      },
    };
  }),

  updatePerformance: (metrics: Partial<PerformanceMetrics>) => set((state) => {
    return {
      ...state,
      ui: {
        ...state.ui,
        performance: {
          ...state.ui.performance,
          ...metrics,
        },
      },
    };
  }),

  updateSettings: (settings: Partial<UISettings>) => set((state) => {
    return {
      ...state,
      ui: {
        ...state.ui,
        settings: {
          ...state.ui.settings,
          ...settings,
        },
      },
    };
  }),

  setHoveredObject: (objectId: string | null) => set((state) => {
    return {
      ...state,
      ui: {
        ...state.ui,
        hoveredObject: objectId,
      },
    };
  }),

  updateInteraction: (interaction: Partial<InteractionState>) => set((state) => {
    return {
      ...state,
      ui: {
        ...state.ui,
        interaction: {
          ...state.ui.interaction,
          ...interaction,
        },
      },
    };
  }),
});